import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaBars, FaTimes, FaLeaf } from 'react-icons/fa'
import { navigationMenu } from '../data/siteData'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      setScrolled(isScrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg py-2' : 'bg-transparent py-4'
    }`}>
      <div className="container-custom">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className={`flex items-center justify-center w-12 h-12 rounded-full ${
              scrolled ? 'bg-primary-500' : 'bg-white'
            } shadow-lg`}>
              <FaLeaf className={`text-xl ${
                scrolled ? 'text-white' : 'text-primary-500'
              }`} />
            </div>
            <div>
              <h1 className={`text-xl font-bold ${
                scrolled ? 'text-gray-900' : 'text-white'
              }`}>
                SCOOP
              </h1>
              <p className={`text-sm ${
                scrolled ? 'text-gray-600' : 'text-gray-200'
              }`}>
                Saint-Louis
              </p>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            {navigationMenu.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className={`font-medium transition-colors duration-300 hover:text-primary-500 ${
                  location.pathname === item.path
                    ? scrolled ? 'text-primary-500' : 'text-accent-300'
                    : scrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-primary-500 hover:bg-gray-100'
              }`}
            >
              Nous contacter
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className={`lg:hidden p-2 rounded-md ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden transition-all duration-300 ${
        isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
      } overflow-hidden bg-white shadow-lg`}>
        <div className="px-4 py-6 space-y-4">
          {navigationMenu.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              onClick={closeMenu}
              className={`block py-2 font-medium transition-colors duration-300 ${
                location.pathname === item.path
                  ? 'text-primary-500'
                  : 'text-gray-700 hover:text-primary-500'
              }`}
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={closeMenu}
            className="block w-full text-center bg-primary-500 text-white py-3 rounded-lg font-medium hover:bg-primary-600 transition-colors duration-300"
          >
            Nous contacter
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navbar 